<p-toast position="bottom-right" [baseZIndex]="5000" key="loading">
  <ng-template let-message pTemplate="message">
    <div class="loading-toaster__container">
      <div class="loading-toaster__summary">
        <stir-common-icons [iconType]="iconType()" width="20" height="20" />{{
          message.summary
        }}
      </div>

      <div class="loading-toaster__content">
        @if (message.detail) {
          <div class="loading-toaster__detail">{{ message.detail }}</div>
        }
        <div class="loading-toaster__progress">
          <p-progress-bar mode="indeterminate" [style]="{ height: '6px' }" />
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
